import React, { useState, useEffect, ChangeEvent } from 'react';
import { Row, Col, Alert } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { DetailItem } from '../../../../features/details';
import { updateTerminal, requestCtmp, configure, getTerminalById, addTerminal } from '../../../../services/api/terminal';
import { getDescriptions } from '../../../../services/api/site'
import { getTerminalMdbSettingById } from '../../../../services/api/terminalMdbSettings'
import { ApiError, Terminal } from '../../../../services/openapi';
import { useKeycloak } from '@react-keycloak/web'
import { PropertyInfo } from '../../../../services/openapi/models/PropertyInfo';
import { Link, useNavigate } from "react-router-dom";
import { NotImplementedWarningModal } from '../../../../components/NotImplementedWarningModal';
import { addLinkedItem, addLinkedItems, deleteAllLinkedItems } from '../../../../services/api/linkedItem';
import TerminalMdbSettingDto from './TerminalMdbSettingDto';
import { getVmcById } from '../../../../services/api/vmc';

const TerminalDetails = () => {
    const [terminal, setTerminal] = useState<any>();
    const [showInputEle, setShowInputEle] = useState<boolean>(false);
    const [showModal, setShowModal] = useState(false);
    const [errorMsg, setErrorMsg] = useState<string[]>([]);
    const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
    const [siteDescriptions, setSiteDescriptions] = useState<Record<string,string>>({});

    const { keycloak } = useKeycloak();
    const token = keycloak.token || '';

   const navigate = useNavigate();
    
    const navigateBack = () => {
        navigate('/dashboard/lists/terminals');
    };

    const setTerminalMdbData = (data: TerminalMdbSettingDto) => {
        localStorage.setItem('TerminalMdbSetting', JSON.stringify(data));
    }

    const setTerminalData = (data: Terminal) => {
        localStorage.setItem('Terminal', JSON.stringify(data));
    }

    const toggleInputElements = (show: boolean) => {
        setShowInputEle(show);
        if (show) {
            document.querySelector('.errorMsg')?.classList.add("d-none");
            errorMsg.length = 0;
        }
    }

    const canConfigureTerminal = (terminal: Terminal) => {
        const errorBox = document.querySelector('.errorMsg')!.classList;
        errorBox.add("d-none");        
        errorMsg.length = 0;

        if (terminal.vmcIds == null || terminal.vmcIds.length === 0) {
            document.querySelector('.errorMsg')?.classList.remove("d-none");
            errorMsg.push('Geen automaat gekoppeld');
            setErrorMsg(errorMsg);
            errorBox.remove("d-none")
            return false;
        }        

        getVmcById(token, terminal.vmcIds.at(0) ?? 0).then(vmc => {
            if (vmc.type == null || vmc.type.length === 0) {
                document.querySelector('.errorMsg')?.classList.remove("d-none");
                errorMsg.push('Automaattype niet ingesteld bij gekoppelde automaat');
                setErrorMsg(errorMsg);
                errorBox.remove("d-none")
                return false;
            }
        }).catch((error: ApiError) => {
            document.querySelector('.errorMsg')?.classList.remove("d-none");
            errorMsg.push('Automaattype kon niet bepaald worden');
            setErrorMsg(errorMsg);
            errorBox.remove("d-none")
            return false;
        });

        return true;
    }

    const configureTerminal = (terminal : Terminal) => {
        configure(keycloak.token || '', (!(terminal.id === undefined) ? terminal.id : 0), "0000").catch((error: ApiError) => {
            try {               
                 pushErrorMessages(JSON.parse(error.body)["errors"]);
                 showErrorMessages();
            } catch (ex) {
                console.log(ex);
                showErrorMessages(["Error handling response"]);
            }
        });
    }

    const pushErrorMessages = (errors: any) => {
        Object.entries<Record<string, any>>(errors).forEach((k: [string, Record<string, any>]) => {
            k[1].forEach((msg: string) => {
                errorMsg.push(msg);
            })
        });
    }

    const showErrorMessages = (errors: string[] | void) => {
        if (errors) {
            errors.forEach((msg: string) => { errorMsg.push(msg); })
        }

        document.querySelector('.errorMsg')?.classList.remove("d-none");
        setIsRefreshing(false);
    }

    useEffect(() => {        
        if (terminal == null) {
            getDescriptions(token).then(map => {
                setSiteDescriptions(map);
            }).catch((ex: ApiError) => {
                console.log(ex);
                showErrorMessages(["Error handling response"]);
            });

            const json = localStorage.getItem('Terminal') ?? "";
            const item = JSON.parse(json);

            item["isConnected"] = item["isConnected"] ? "Online" : "Offline";

            setTerminal(item);

            errorMsg.length = 0;        
            document.querySelector('.errorMsg')?.classList.add("d-none");

            if (item["id"] === 0) {
                toggleInputElements(true);
            }
        }              
    }, [isRefreshing, terminal]);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        
        document.querySelector('.errorMsg')?.classList.add("d-none");
        errorMsg.length = 0;

        if (e.currentTarget.checkValidity()) {
            let t: Terminal = terminal;
            setTerminalData(t);
            setIsRefreshing(true);

            if (t.id === 0) {
                addTerminal(token, t).then((id) => {
                    if (id) {
                        let t: Terminal = terminal;
                        t.id = id;
                        t.status = "Offline";
                        setTerminal(t);
                        setTerminalData(t);
                        setIsRefreshing(false);
                    }
                }).catch((error: ApiError) => {
                    try {
                        document.querySelector('.errorMsg')?.classList.remove("d-none");
                        if (error.body) {
                            pushErrorMessages(JSON.parse(error.body)["errors"]);
                            showErrorMessages();
                        }
                        else {
                            showErrorMessages([error.message]);
                        }                        
                    } catch (ex) {
                        console.log(ex);
                        showErrorMessages(["Error handling response"]);
                    }
                });
            }
            else {
                updateTerminal(token, t.id ?? 0, t).then(() => { setIsRefreshing(false); navigateBack(); }).catch((error: ApiError) => {                    
                    try {
                        document.querySelector('.errorMsg')?.classList.remove("d-none");
                        pushErrorMessages(JSON.parse(error.body)["errors"]);
                        showErrorMessages();
                    } catch (ex) {
                        console.log(ex);
                        showErrorMessages(["Error handling response"]);
                    }
                });
            }
            setShowInputEle(!showInputEle);             
        }
    }

    function isConfigureBtnDisabled(): boolean {
        if (terminal == null || terminal === undefined) {
            return true;
        }

        const notConnected = terminal.isConnected !== "Online";
        const ecrStateInConfigure = terminal.ecrState.startsWith('Vas');
        //const vasStateIsNotReadyForConfig = terminal.vasState != 'operational' && terminal.vasState != 'not_configured'
        const vasStateNotIdleOrTimeout = terminal.vasState != 'idle' && terminal.vasState != 'timeout' && terminal.vasState != 'vas_not_configured';

        return notConnected || ecrStateInConfigure || vasStateNotIdleOrTimeout/*|| vasStateIsNotReadyForConfig*/;
    }

    let idx = 0;
    
    return (
        <>
            <div className="">
                <NotImplementedWarningModal
                    showModal={showModal}
                    handleClose={() => {
                        setShowModal(false);
                    }}
                />
            </div>
            <Row className="">
                <Col className="">
                    <Card className="rounded">
                        <Card.Body className="">
                            <form onSubmit={e => handleSubmit(e)}>
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="">
                                    <Col sm="12" className="">
                                        <h4 className="mb-2 qvend-title">Terminal{terminal?.id ? ("details") : (" toevoegen")}</h4>
                                    </Col>
                                </Row>
                                <Row className="">
                                    <Col sm="12" xs="12" className="mt-2">
                                        <div className="table-responsive-lg" style={{ overflowX: 'hidden' }}>
                                            <div>
                                                {terminal && Object.entries<PropertyInfo>(terminal).filter(([key, value]) => terminal["propertyNames"][key] !== undefined && (terminal["propertyNames"][key].editType !== '' || (terminal["propertyNames"][key].editType === '' && value !== null))).sort((a, b) => terminal["propertyNames"][a[0]].sortOrderLevel - terminal["propertyNames"][b[0]].sortOrderLevel).map(([key, value], index) => (
                                                    hasRole(terminal, key, keycloak) && !(terminal.id === 0 && terminal["propertyNames"][key].editType === "") && (
                                                        <DetailItem key={index} propertyName={terminal["propertyNames"][key].name} defaultValue={value ?? ""} rowColor={
                                                            ((terminal["propertyNames"][key].hideOnNull && (value == null || value === undefined) ? idx : idx++)) % 2 ? "#cfd5ea" : "#e9ebf5"
                                                        } editType={terminal["propertyNames"][key].editType} pattern={terminal["propertyNames"][key].valPattern} hideOnNull={terminal["propertyNames"][key].hideOnNull}
                                                            handleDoubleClick={() => toggleInputElements(true)}
                                                            handleChange={(e: ChangeEvent<HTMLInputElement>) => { terminal[key] = (e.target.value); if (key === 'siteId') { terminal.vmcIds = null } setTerminal(terminal); }} showInputEle={showInputEle} possibilities={terminal["propertyNames"][key].predefinedValues} possibilityDescriptions={ siteDescriptions }></DetailItem>)
                                                ))}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="d-none errorMsg">
                                    <Col>
                                        {
                                            errorMsg.map((item, index) => {
                                                return <Alert key={index} variant="warning" className="alert" role="alert">
                                                           <span>{item}</span>
                                                       </Alert>;
                                            })
                                        }
                                    </Col>
                                </Row>
                                { terminal && (terminal?.id > 0) && <>
                                <Row style={{ paddingTop: "12px" }}>
                                    <Col>
                                        <Link to="/dashboard/details/terminal-mdb-settings" onClick={() => {
                                            getTerminalMdbSettingById(token, terminal?.id).then((setting) => { if (setting) { setTerminalMdbData(setting) } }).catch((error: ApiError) => {
                                                try {
                                                    document.querySelector('.errorMsg')?.classList.remove("d-none");
                                                    Object.entries<Record<string, any>>(JSON.parse(error.body)["errors"]).forEach((k) => { k[1].forEach((msg: string) => { errorMsg.push(msg); setErrorMsg(errorMsg); }) });
                                                } catch (ex) {
                                                    errorMsg.push("Error handling response");
                                                    setErrorMsg(errorMsg);
                                                }
                                            }); }}>
                                            <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px' }}>MDB</button>
                                        </Link>
                                    </Col>
                                    <Col className="text-end">
                                        <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px' }} onClick={() => requestCtmp(keycloak.token || '', (!(terminal.id === undefined) ? terminal.id : 0))}>CTMP</button>
                                    </Col>
                                </Row>
                                <Row style={{ paddingTop: "3px" }}>
                                    <Col>                                        
                                        <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px' }} onClick={() => {
                                            document.querySelector('.errorMsg')?.classList.add("d-none");
                                            errorMsg.length = 0;

                                            deleteAllLinkedItems(token, terminal.id ?? 0, 'Terminal', "Location").then(() => {
                                                if (terminal.locationId) {
                                                    addLinkedItem(token, { parentId: terminal.id ?? 0, parentType: 'Terminal', linkedEntityId: terminal.locationId, linkedEntityType: "Location" }).then(() => {
                                                        navigate('/dashboard/items-linkers/location-to-terminal');
                                                    }).catch((error: ApiError) => {
                                                        try {
                                                            document.querySelector('.errorMsg')?.classList.remove("d-none");
                                                            Object.entries<Record<string, any>>(JSON.parse(error.body)["errors"]).forEach((k) => { k[1].forEach((msg: string) => { errorMsg.push(msg); setErrorMsg(errorMsg); }) });
                                                        } catch (ex) {
                                                            errorMsg.push("Error handling response");
                                                            setErrorMsg(errorMsg);
                                                        }
                                                    });
                                                }
                                                else {
                                                    navigate('/dashboard/items-linkers/location-to-terminal');
                                                }
                                            }).catch((error: ApiError) => {
                                                try {
                                                    document.querySelector('.errorMsg')?.classList.remove("d-none");
                                                    Object.entries<Record<string, any>>(JSON.parse(error.body)["errors"]).forEach((k) => { k[1].forEach((msg: string) => { errorMsg.push(msg); setErrorMsg(errorMsg); }) });
                                                } catch (ex) {
                                                    errorMsg.push("Error handling response");
                                                    setErrorMsg(errorMsg);
                                                }
                                            });                                                
                                        }}>Locatie</button>
                                    </Col>
                                    <Col className="text-end">
                                        <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px' }} onClick={() => {
                                            document.querySelector('.errorMsg')?.classList.add("d-none");
                                            errorMsg.length = 0;

                                            deleteAllLinkedItems(token, terminal.id ?? 0, 'Terminal', "Vmc").then(() => {
                                                if (terminal.vmcIds) {                                                    
                                                    addLinkedItems(token, terminal.id ?? 0, 'Terminal', "Vmc", terminal.vmcIds).then(() => {
                                                        navigate('/dashboard/items-linkers/vmc-to-terminal');
                                                    }).catch((error: ApiError) => {
                                                        try {
                                                            document.querySelector('.errorMsg')?.classList.remove("d-none");
                                                            Object.entries<Record<string, any>>(JSON.parse(error.body)["errors"]).forEach((k) => { k[1].forEach((msg: string) => { errorMsg.push(msg); setErrorMsg(errorMsg); }) });
                                                        } catch (ex) {
                                                            errorMsg.push("Error handling response");
                                                            setErrorMsg(errorMsg);
                                                        }
                                                    });
                                                }
                                                else {
                                                    navigate('/dashboard/items-linkers/vmc-to-terminal');
                                                }
                                            }).catch((error: ApiError) => {
                                                try {
                                                    document.querySelector('.errorMsg')?.classList.remove("d-none");
                                                    Object.entries<Record<string, any>>(JSON.parse(error.body)["errors"]).forEach((k) => { k[1].forEach((msg: string) => { errorMsg.push(msg); setErrorMsg(errorMsg); }) });
                                                } catch (ex) {
                                                    errorMsg.push("Error handling response");
                                                    setErrorMsg(errorMsg);
                                                }
                                            });
                                        }}>Automaten</button>
                                    </Col>
                                </Row>
                                <Row style={{ paddingTop: "3px" }}>
                                    <Col>
                                        <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px' }} onClick={() => {
                                            document.querySelector('.errorMsg')?.classList.add("d-none");
                                            errorMsg.length = 0;

                                            setIsRefreshing(true);
                                            getTerminalById(token, terminal.id ?? 0).then((t) => {
                                                if (t) {
                                                    let oldTerminal = terminal as Terminal;
                                                    const propertyNames = oldTerminal.propertyNames;
                                                    const vmcIds = oldTerminal.vmcIds;
                                                    t.propertyNames = propertyNames;
                                                    t.vmcIds = vmcIds;
                                                    t.siteId = oldTerminal.siteId;

                                                    let term = t as any;

                                                    term["isConnected"] = term["isConnected"] ? "Online" : "Offline";
                                                    
                                                    if (t.vasResponseState !== null && t.vasResponseState !== "" && oldTerminal.vasResponseState != t.vasResponseState) {
                                                        document.querySelector('.errorMsg')?.classList.remove("d-none");
                                                        const msg = "Configureren niet gelukt, probeer het later nog eens (" + t.vasResponseState + ")";

                                                        showErrorMessages([msg]);
                                                        const button = document.querySelector("#BtnConf") as HTMLButtonElement;
                                                        if (button) {
                                                            button.disabled = isConfigureBtnDisabled();
                                                        }
                                                    }                                                    

                                                    setTerminal(term);
                                                    setTerminalData(t);
                                                    setIsRefreshing(false);
                                                }
                                            }).catch((error: ApiError) => {
                                                try {
                                                    document.querySelector('.errorMsg')?.classList.remove("d-none");
                                                    pushErrorMessages(JSON.parse(error.body)["errors"]);
                                                    showErrorMessages();
                                                    //Object.entries<Record<string, any>>(JSON.parse(error.body)["errors"]).forEach((k) => { k[1].forEach((msg: string) => { errorMsg.push(msg); setErrorMsg(errorMsg); }) });
                                                } catch (ex) {
                                                    showErrorMessages(["Error handling response"]);
                                                }
                                            });
                                                const button = document.querySelector("#BtnConf") as HTMLButtonElement;
                                                if (button) {
                                                    button.disabled = isConfigureBtnDisabled();
                                                }

                                        }}>Verversen</button>
                                    </Col>
                                    <Col className="text-end">
                                            <button type="button" id="BtnConf" className="btn btn-fixed-width" disabled={isConfigureBtnDisabled()} style={{ fontSize: '11px' }} onClick={(e) => {
                                                e.currentTarget.disabled = true; if (canConfigureTerminal(terminal)) {
                                                    configureTerminal(terminal);
                                                } }}>Configureer</button>                                        
                                    </Col>
                                </Row>
                                </>}
                                <Row style={{ paddingTop: "3px" }}>
                                    <Col>
                                        <Link to="/dashboard/lists/terminals" onClick={() => { }}>
                                            <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px', backgroundColor: "red" }} onClick={() => { }}>Terug</button>
                                        </Link>
                                    </Col>
                                    <Col className="text-end">
                                        {showInputEle ?
                                            (<button type="submit" className="btn btn-fixed-width" style={{ fontSize: '11px' }}>Opslaan</button>) :
                                            (<button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px' }} onClick={(e) => { e.preventDefault(); toggleInputElements(true); }}>Wijzigen</button>)
                                        }
                                    </Col>
                                </Row>
                            </form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default TerminalDetails;

function hasRole(terminal: any, key: string, keycloak: any) {
    if (!(terminal && terminal!.propertyNames)) {
        return false;
    }

    const roleNames = terminal["propertyNames"][key].roleNames;
    let result: boolean = false;
    var returnValue = roleNames === null || keycloak && roleNames.map((role: string) => { result = result || keycloak.hasResourceRole(role) }) && result;
    return returnValue;
}
